<template>
    <div class="btn-box">
        <el-button class="btn luyin" @click="showLuyin">网页录音</el-button>
<!--        <el-button class="btn luyin" @click="handleClickStart">录音</el-button>-->
<!--        <el-button class="btn luyin" @click="handleClickPause">暂停录音</el-button>-->
<!--        <el-button class="btn luyin" @click="handleClickResume">继续录音</el-button>-->
<!--        <el-button class="btn luyin" @click="handleClickStop">停止录音</el-button>-->
<!--        <el-button class="btn luyin" @click="handleClickDown">下载录音</el-button>-->
<!--        <el-button class="btn luyin" @click="handleClickGetBlob">获取录音</el-button>-->
<!--        <el-button class="btn luyin" @click="handleClickPlay">播放录音</el-button>-->
<!--        <el-button class="btn luyin" @click="handleClickDestroy">销毁录音</el-button>-->
<!--        <el-button class="btn luyin" @click="handleClickPlayBlob">播放外部音频流</el-button>-->
<!--        <el-button class="btn luyin" @click="handleClickGetData">获取录音波</el-button>-->
<!--        <el-button class="btn luyin" @click="handleClickOnprogress">录音实时回调</el-button>-->
        <LuyinDialog
            v-if="isVisible"
            :visible.sync="isVisible"
            :time.sync="time"
            :isShop="isShop"
            @handleClickStart="handleClickStart"
            @handleClickPause="handleClickPause"
            @handleClickResume="handleClickResume"
            @handleClickStop="handleClickStop"
            @onLuyinDialog="onLuyinDialog"
            @fnTimeDestory="fnTimeDestory"
            @fnTimeStart="fnTimeStart"
            @audioRecorderPlay="handleClickPlay"
            @close="handleClickDestroy"
        />
    </div>
</template>

<script>
    import {mapActions} from 'vuex'
    import LuyinDialog from './components/luyinDialog'
    import {
        audioRecorderStart,
        audioRecorderPause,
        audioRecorderResume,
        audioRecorderDestroy,
        audioRecorderStop,
        audioRecorderPlay,
        audioRecorderDownloadWAV,
        audioRecorderGetWAV,
        audioRecorderGetWAVBlob,
        audioRecorderPlayAudio,
        audioRecorderGetRecordAnalyseData,
        audioRecorderOnprogress,
        convertToMp3
    } from "../../../../../../../../utils/recorder";

    export default {
        name: "luyin-btn",
        components: {
            LuyinDialog
        },
        props: {
            isShop: {
                type: Boolean,
                default: false
            },
        },
        watch: {
            isVisible(state) {
                if(state){
                    this.setSendKeyBoardToCocos({key: 'isLuyin', value: false})
                }else{
                    this.setSendKeyBoardToCocos({key: 'isLuyin', value: true})
                }
            },
        },
        data(){
            return {
                isVisible: false,
                time: 0,
                fnTime: null //计时器
            }
        },
        methods: {
            ...mapActions(['setSendKeyBoardToCocos']),
            clearAll(){
                this.fnTimeDestory()
                this.isVisible = false
                this.time = 0
                this.fnTime = null
            },
            onLuyinDialog(data){
                // 真实上传
                console.log('数据流==>', data, convertToMp3(audioRecorderGetWAV()))
                // this.handleClickDown(data)
                this.$emit('onLuyinBtn', {...data, row:convertToMp3(audioRecorderGetWAV()), isShop: this.isShop})
                this.handleClickDestroy()
                this.clearAll()
            },
            handleClickOpt(func){
                func()
            },
            showLuyin(){
                this.isVisible = true
            },
            handleClickStart(){
                audioRecorderStart((res)=>{
                    console.log('录音中==>', res)
                    this.fnTimeStart()
                })
            },
            timeGo(){  //每隔1秒让++i
                this.fnTimeDestory()
                this.time = this.time + 1
                this.fnTime = setTimeout(this.timeGo,1000);
            },
            // 开始计时器
            fnTimeStart(){
                this.timeGo()
            },
            // 销毁计时器
            fnTimeDestory(){
                clearInterval(this.fnTime)
            },
            handleClickPause(){
                audioRecorderPause()
            },
            handleClickResume(){
                audioRecorderResume()
            },
            handleClickStop(){
                audioRecorderStop()
                console.log('停止录音==>')
            },
            handleClickPlay(){
                audioRecorderPlay()
                console.log('播放录音==>')
            },
            handleClickDown(obj){
                audioRecorderDownloadWAV({fileName: obj.name})
            },
            handleClickGetBlob(){
                let blob = audioRecorderGetWAVBlob()
                // this.handleClickPlayBlob(blob)
                console.log('获取录音数据==>', blob)
            },
            handleClickDestroy(){
                this.clearAll()
                audioRecorderDestroy()
            },
            handleClickPlayBlob(blob){
                audioRecorderPlayAudio({Blob: blob})
            },
            handleClickGetData(){
                console.log(audioRecorderGetRecordAnalyseData())
            },
            handleClickOnprogress(){
                audioRecorderOnprogress(res=>{
                    console.log('实时数据==>', res)
                })
            },
            close () {
                this.isVisible = false
            }
        }
    }
</script>

<style lang="scss" scoped>
.btn-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
    /*margin: 40px 0px;*/
    width: 100%;

    height:40px;
    background:rgba(255, 120, 56,1);
    border-radius:4px;
}
.luyin {
    /*background-color: #fed800;*/
    width: 100%;
    background:#e7622e !important;
    border: none;
    outline: none;
    font-size: 18px;
    height: 40px;
    color: white !important;
    border-radius: 20px;

    &:hover,&:active{
        opacity: .8;
    }
}
</style>
